var $f0ba4c280cbcc7f2$exports = {};
$f0ba4c280cbcc7f2$exports = {
    "colorFormat": `Renk format\u{131}`,
    "hex": `Hex`,
    "hsb": `HSB`,
    "hsl": `HSL`,
    "rgb": `RGB`
};


export {$f0ba4c280cbcc7f2$exports as default};
//# sourceMappingURL=tr-TR.mjs.map
